import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const FIELDS = [
  { name: "name", label: "Full name", type: "text", placeholder: "Ada Lovelace", auto: "name" },
  { name: "email", label: "Email", type: "email", placeholder: "you@company.com", auto: "email" },
  { name: "password", label: "Password", type: "password", placeholder: "••••••••", auto: "new-password" },
  { name: "password2", label: "Confirm password", type: "password", placeholder: "••••••••", auto: "new-password" },
];

const Register = () => {
  const [userData, setUserData] = useState({ name: "", email: "", password: "", password2: "" });
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const changeInputHandler = (e) =>
    setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const registerUser = async (e) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/users/register`, userData);
      if (!response.data) {
        setError("Couldn't register user. Please try again");
      } else {
        navigate("/login");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Couldn't create your account.");
    }
    setIsSubmitting(false);
  };

  return (
    <section className="auth">
      <div className="card auth__card reveal">
        <div className="auth__head">
          <span className="brand__mark">B</span>
          <h1>
            Create your <span className="ink-italic">account.</span>
          </h1>
          <p>Join the community and start publishing in minutes.</p>
        </div>

        <form className="form" onSubmit={registerUser}>
          {error && <p className="alert">{error}</p>}
          {FIELDS.map((f, i) => (
            <div className="field" key={f.name}>
              <label className="field__label" htmlFor={f.name}>
                {f.label}
              </label>
              <input
                id={f.name}
                className="input"
                type={f.type}
                name={f.name}
                placeholder={f.placeholder}
                value={userData[f.name]}
                onChange={changeInputHandler}
                autoComplete={f.auto}
                autoFocus={i === 0}
              />
            </div>
          ))}
          <button type="submit" className="btn btn--primary btn--block btn--lg" disabled={isSubmitting}>
            {isSubmitting ? "Creating account…" : "Create account"}
          </button>
        </form>

        <p className="auth__switch">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </section>
  );
};

export default Register;
